export default __webpack_public_path__ + "static/media/sparkles-no-3.9566e745.mid";